import { ImageUpload } from "@/components/ImageUpload";
import { imgUrl } from "@/lib/api";
import { X } from "lucide-react";

export function GalleryEditor({ value = [], onChange, testid = "gallery-editor" }) {
  const add = (url) => { if (url) onChange([...(value || []), url]); };
  const remove = (i) => onChange((value || []).filter((_, idx) => idx !== i));
  return (
    <div data-testid={testid}>
      {(value || []).length > 0 && (
        <div className="grid grid-cols-3 md:grid-cols-4 gap-2 mb-3">
          {value.map((src, i) => (
            <div key={i} className="relative aspect-square rounded-lg overflow-hidden border border-stone-200">
              <img src={imgUrl(src)} alt={`gallery-${i}`} className="h-full w-full object-cover" />
              <button
                type="button"
                data-testid={`${testid}-remove-${i}`}
                onClick={() => remove(i)}
                className="absolute top-1 right-1 h-6 w-6 grid place-items-center bg-black/60 text-white rounded-full hover:bg-black/80"
              >
                <X className="h-3.5 w-3.5" />
              </button>
            </div>
          ))}
        </div>
      )}
      <ImageUpload value="" onChange={add} label="Add a past-event photo" testid={`${testid}-upload`} aspect="aspect-[3/1]" />
    </div>
  );
}
